import { render, staticRenderFns } from "./RichContentOptions.vue?vue&type=template&id=4bbd30e0"
import script from "./RichContentOptions.vue?vue&type=script&lang=js"
export * from "./RichContentOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports